'use client';

import { useTranslations } from 'next-intl';

import { EntitySearchInterface } from '@/components/EntitySearch/EntitySearchInterface';
import type { Meilisearch_LieuEdition } from '@/lib/api/meilisearch-types';
import { Env } from '@/lib/Env';

import { LieuEditionCard } from '../oldrecherche/components/widgets/LieuEditionHit';

export function LieuxSearchInterface() {
  const t = useTranslations('Pages.TousLesLieux');

  return (
    <EntitySearchInterface<Meilisearch_LieuEdition>
      apiKey={Env.NEXT_PUBLIC_MEILISEARCH_KEY}
      indexName="lieux_edition"
      entityType="lieux_edition"
      searchPlaceholder={
        t('placeholder_recherche') || 'Rechercher un éditeur par nom...'
      }
      filtersConfig={[]}
      renderHitCard={(hit) => <LieuEditionCard lieu={hit} />}
      customNoResultsMessages={{
        titre: t('aucun_resultat') || 'Aucun éditeur trouvé',
        message:
          t('aucun_resultat_message') ||
          "Essayez d'élargir votre recherche en modifiant les filtres.",
      }}
      linkToGlobalSearchOnNoResults={false}
    />
  );
}
